module.exports = __webpack_public_path__ + "static/media/ic_Landing_Pages.453be829.svg";